import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import { NotFoundRoute } from './NotFoundRoute';
import { useGetItemIdFromRouter } from './useGetItemIdFromRoute';

const EpisodesRoute: React.FC = () => {
  const itemId = useGetItemIdFromRouter();

  if (!itemId) {
    return <NotFoundRoute />; // 404
  }

  return (
    <SuspenseWrapper>
      <AuthRequired>
        <EpisodesComponent itemId={itemId} />
      </AuthRequired>
    </SuspenseWrapper>
  );
};

const EpisodesComponent = React.lazy(() => import('../Episodes/Episodes'));
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

export default EpisodesRoute;
